import React from 'react';
import '../Theme.css';

import Helmet from 'react-helmet';

const Downloads = () => {
  return (
    <div>
      <Helmet>
        <title>JMKit.com: Downloads</title>
      </Helmet>
      <h1>Downloads Page</h1>
      <h2>Coming soon...</h2>
    </div>
  );
};

export default Downloads;
